// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__fkqyl","colMin":"styles_colMin__3lvAU"};